export class TenantSystemSettings {
  public static readonly DEFAULT = new TenantSystemSettings(true, true, true, true, false);

  constructor(
    public isGenderFieldEnabled: boolean,
    public isRaceFieldEnabled: boolean,
    public isAvatarFieldEnabled: boolean,
    public isLinkedInFieldEnabled: boolean,
    public isTestModeEnabled: boolean
  ) {}

  static parse(obj: Partial<TenantSystemSettings>): TenantSystemSettings {
    return obj
      ? new TenantSystemSettings(
          obj.isGenderFieldEnabled ?? true,
          obj.isRaceFieldEnabled ?? true,
          obj.isAvatarFieldEnabled ?? true,
          obj.isLinkedInFieldEnabled ?? true,
          obj.isTestModeEnabled ?? false
        )
      : TenantSystemSettings.DEFAULT;
  }
}
